"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountyValueProvider = void 0;
const hooks_1 = require("../../../../ui/hooks");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
function useCountyValueProvider(params) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const client = (0, hooks_1.usePublicDataClient)(params === null || params === void 0 ? void 0 : params.appName, params === null || params === void 0 ? void 0 : params.baseUrl);
    return {
        type: 'classifier.county',
        label: t('defaultClassifiers.county'),
        getValues: (params) => {
            if (typeof params === 'string') {
                return client.publicDataGetObject('classifier-county-' + params);
            }
            else {
                return Promise.resolve([]);
            }
        },
    };
}
exports.useCountyValueProvider = useCountyValueProvider;
